import { render, staticRenderFns } from "./CustomerDetail-History.vue?vue&type=template&id=14ace42a"
import script from "./CustomerDetail-History.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports